import { IconButton, Chip } from "@mui/material";
import { RequestContext } from "../models/request";
import { useContext, useState } from "react";
import { Button, Icon, Input, Modal, ModalBody, ModalFooter, ModalHeader } from "design-react-kit";
import ApiService from '../../../services/api';
import Loading from "../../components/loading";
import { ActaAuthContext } from "pa_kit/auth";

const RequestControlProtocol = (props:any) => {
    const requestInterface  = useContext(RequestContext);
    const auth = useContext<any>(ActaAuthContext);
    const user = auth.user;
    
    var originalRequest = props.request;
    if(originalRequest == null){
        originalRequest = requestInterface.request;
    }
    const [request, setRequest]     = useState(originalRequest);
    
    const [isLoading, setIsLoading]     = useState(false);
    const [isModalOpen, setModalOpen]   = useState(false);
    const [protocolId, setProtocolId]   = useState(request.protocolId ?? "");
    

    
    if(!user.hasPermissions()) return <></>;

    const saveNewProtocolId = async () => {
        if(protocolId.length < 3) return;
        setIsLoading(true);
        const result = await ApiService.saveRequestProtocolId(request,protocolId);
        setIsLoading(false);
        requestInterface.fetchRequest();
        setRequest(result);
    }
    const clearProtocolId = async () => {
        setIsLoading(true);
        //const result = await ApiService.setRequestStatus(request,newStatus,notify,note);
        setIsLoading(false);
        requestInterface.fetchRequest();
        setModalOpen(false);
    }
    const sendToProtocol = async () => {
        setIsLoading(true);
        const result = await ApiService.sendRequestToProtocol(request);
        setIsLoading(false);
        requestInterface.fetchRequest();
        setRequest(result)
    }
    

    if(request.protocolAssigned){
        return (
            <>  
                <Chip 
                    icon={<Icon icon="it-folder" style={{ paddingRight: "-12px" }} color="success" />} 
                    label={request.protocolId}
                    color="success"
                    variant="outlined"
                    onClick={() => setModalOpen(true)}
                />
                
                {/*
                <IconButton onClick={() => setModalOpen(true)} style={{ width: "100%", justifyContent: "flex-start" }}>
                    <Icon icon="it-check-circle" color="success" /> <small style={{ marginLeft: 10 }}>{ request.protocolId }</small>
                </IconButton>
                */}
    
                <Modal isOpen={isModalOpen} toggle={() => setModalOpen(!isModalOpen)} size="lg" labelledBy='esempio13' zIndex={9999}>
                    <ModalHeader toggle={() => setModalOpen(!isModalOpen)} id='esempio13'>
                        Stato protocollo
                    </ModalHeader>
                    <ModalBody>
                        {(isLoading) 
                            ? <Loading />
                            : <>
                                <h6>Numero di protocollo correttamente assegnato alla pratica</h6>
                                <div style={{ marginBottom: 20 }} >
                                    Pratica numero: {request.id}<br/>
                                    <br/>
                                    Il numero sul sistema di protocollo digitale per questa pratica è il seguente:<br/>
                                    <br/>
                                    <ul>
                                        <li>
                                            <strong>Numero protocollo:</strong><br/>
                                            { request.protocolId }
                                        </li>
                                    </ul>
                                </div>
                            </>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button color='secondary' onClick={() => setModalOpen(false)}>
                            Chiudi
                        </Button>
                        {/*
                        <Button color='danger' onClick={() => clearProtocolId()}>
                            Cancella numero di protocollo assegnato
                        </Button>
                        */}
                    </ModalFooter>
                </Modal>
            </>
        );
    }

    if(request.protocolSent){
        return (
            <>
                <Chip 
                    icon={<Icon icon="it-folder" style={{ paddingRight: "-12px" }} color="warning" />} 
                    label="inviata"
                    color="warning"
                    variant="outlined"
                    onClick={() => setModalOpen(true)}
                />
                {/*
                <IconButton onClick={() => setModalOpen(true)}><Icon icon="it-warning-circle" color="warning" /></IconButton>
                */}
                <Modal isOpen={isModalOpen} toggle={() => setModalOpen(!isModalOpen)} size="lg" labelledBy='esempio13' zIndex={9999}>
                    <ModalHeader toggle={() => setModalOpen(!isModalOpen)} id='esempio13'>
                        Stato protocollo
                    </ModalHeader>
                    <ModalBody>
                        {(isLoading) 
                            ? <Loading />
                            : <>
                                <h6>Numero di protocollo non assegnato</h6>
                                <div style={{ marginBottom: 40 }} >
                                    Pratica numero: {request.id}<br/>
                                    <br/>
                                    A questa pratica non è stato ancora assegnato il numero di protocollo.<br/>
                                    Individua la pratica sul protocollo digitale corrispndente ai seguenti dati:<br/>
                                    <br/>
                                    <ul>
                                        <li>
                                            <strong>Oggetto:</strong><br/>
                                            { request.protocolSubject }
                                        </li>
                                        <li>
                                            <strong>Inviata da:</strong><br/>
                                            { request.user["first_name"] } { request.user["last_name"] }
                                        </li>
                                        <li>
                                            <strong>Inviata il:</strong><br/>
                                            { request.protocolSent?.toLocaleDateString() } alle { request.protocolSent?.toLocaleTimeString() }
                                        </li>
                                    </ul>
                                    Una volta individuata, inserisci in numero nel campo sottostante e clicca su <strong>Assegna numero protocollo</strong>.
                                </div>
                                <div style={{ marginBottom: 20 }} >
                                    <Input type='text' label='Numero di protocollo' id="protocolId" value={protocolId} onChange={(e) => setProtocolId(e.target.value)} />
                                </div>
                            </>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button color='secondary' onClick={() => setModalOpen(false)}>
                            Chiudi
                        </Button>
                        <Button color='success' onClick={() => saveNewProtocolId()} disabled={ protocolId.length < 3 }>
                            Assegna numero protocollo
                    </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }


    return (
        <>
            <Chip 
                icon={<Icon icon="it-folder" style={{ paddingRight: "-12px" }} color="error" />} 
                label="non inviata"
                color="error"
                variant="outlined"
                onClick={() => setModalOpen(true)}
            />
            {/*
            <IconButton onClick={() => setModalOpen(true)}><Icon icon="it-warning-circle" color="error" /></IconButton>
            */}
            <Modal isOpen={isModalOpen} toggle={() => setModalOpen(!isModalOpen)} size="lg" labelledBy='esempio13'>
                <ModalHeader toggle={() => setModalOpen(!isModalOpen)} id='esempio13'>
                    Stato protocollo
                </ModalHeader>
                <ModalBody>
                    {(isLoading) 
                        ? <Loading />
                        : <>
                            <h6>Pratica non inviata al protocollo</h6>
                            <div style={{ marginBottom: 20 }} >
                                Pratica numero: {request.id}<br/>
                                <br/>
                                Questa pratica non è stata ancora inviata al protocollo elettronico.<br/>
                                Potrebbe essersi verificato un errore un fase di invio automatico, clicca sul <strong>Invia al protocollo</strong> per inviarla adesso.<br/>
                                <br/>
                                Una volta inviata sarà possibile inserire il numero di protocollo assegnato dal protocollo digitale.
                            </div>
                        </>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button color='secondary' onClick={() => setModalOpen(false)}>
                        Chiudi
                    </Button>
                    <Button color='primary' onClick={() => sendToProtocol()}>
                        Invia al protocollo
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
 }
 export default RequestControlProtocol;